import {api} from '../constants/user_cards';
import { setCards, addCard, removeCard, editCard } from '../state/ducks/user_cards';
import { httpClient } from './httpClient';
import log from './logger/log';
import { dispatch } from '../state/store';

const getAllCardsAsync = () => {
    return httpClient.get(api.GET_CARDS_LIST_API);
}

const getCardsAsync = async (filter, token) => {
    const url = api.GET_CARDS_LIST_API;

    let postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: filter.sortFilter
    }
    
    try {
        if(token) {
            token.throwIfCanceled();
        }
        const data = await httpClient.post(url, postData);
        let cards = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }

        if(token) {
            token.throwIfCanceled();
        }
        dispatch(setCards(cards.items, cards.filter));
    }
    catch (error){
        log.error(JSON.stringify(error));
        throw error;
    }
};

const getCardAsync = async (cardId) => {
    const url = api.GET_CARD_API + "?id=" + cardId;
    try {
        const data = await httpClient.get(url);
        return data;
    }
    catch (error) {
        log.error(JSON.stringify(error))
        return null;
    }
};

const addCardAsync = async (newCard) => {
    const url = api.ADD_CARD_API;
    try {
        const card = await httpClient.post(url, newCard);        
        dispatch(addCard(card));
    }
    catch (error) {
        log.error(JSON.stringify(error))
        throw error;
    }
};

const editCardAsync = async (editedCard) => {
    const url = api.EDIT_CARD_API;
    try {
        const card = await httpClient.post(url, editedCard);
        dispatch(editCard(card));
    }
    catch (error) {
        log.error(JSON.stringify(error))
        throw error;
    }
};

const removeCardAsync = async (card) => {
    const url = api.REMOVE_CARD_API + "?id=" + card.userCardId;
    try {
        await httpClient.get(url);
        dispatch(removeCard(card));
    }
    catch (error) {
        log.error(JSON.stringify(error))
    }
}

const userCardService = {
    getCardsAsync,
    getCardAsync,
    getAllCardsAsync,
    addCardAsync,
    editCardAsync,
    removeCardAsync
}

export default userCardService;